import React from 'react';
import QuestionsBoxView from '../view/QuestionsBoxView';

const QuestionsBoxEngine = ({
  disabledButtons,
  fields,
  onClickField = () => {}
}) => {
  const viewProps = {
    disableQuestions: disabledButtons.includes('fields'),
    fields,
    onClickField
  };

  return <QuestionsBoxView {...viewProps} />;
};

export default QuestionsBoxEngine;
